const pricingPlans = {
    default_plan: 'starter',
    plans: [
        {
            id: 'starter',
            label: 'Starter',
            daily_agent_message_limit: 5,
            price: 0,
        },
        {
            id: 'hobby',
            label: 'Hobby',
            daily_agent_message_limit: 50,
            price: 10,
        },
        {
            id: 'professional',
            label: 'Professional',
            daily_agent_message_limit: null,
            price: 50,
        },
    ],
};

export default pricingPlans;
